"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functionalButton = require("@widget/functional-button");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function ModifyForm(_ref) {
  var disabled = _ref.disabled,
      handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      pristine = _ref.pristine;

  try {
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['form'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
      name: "name",
      disabled: disabled
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0421\u0430\u0439\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430",
      name: "webSite",
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _defaultModule["default"]['information']
    }, "\u0421\u0430\u0439\u0442 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u043D\u0430\u0447\u0438\u043D\u0430\u0442\u044C\u0441\u044F \u0441\xA0http:// \u0438\u043B\u0438 https://", /*#__PURE__*/_react["default"].createElement("br", null), "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435 \u043F\u0443\u0441\u0442\u044B\u043C, \u0435\u0441\u043B\u0438 \u0443\xA0\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430 \u043D\u0435\u0442 \u0441\u0430\u0439\u0442\u0430"))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.CheckboxField, {
      className: _defaultModule["default"]['switch'],
      type: 'switch',
      name: "demoMode",
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'body'
    }, "\u0422\u0435\u0441\u0442\u043E\u0432\u044B\u0439 \u043C\u0430\u0433\u0430\u0437\u0438\u043D")))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438",
      type: 'phone',
      name: "supportPhone",
      disabled: disabled
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, null, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      label: "Email \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438",
      name: "supportEmail",
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: _defaultModule["default"]['information']
    }, "\u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0438 email \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438", /*#__PURE__*/_react["default"].createElement("br", null), "\u0431\u0443\u0434\u0443\u0442 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u043A\u0432\u0438\u0442\u0430\u043D\u0446\u0438\u0438"))), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['form__controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": "submit",
      type: "submit",
      mode: "success",
      inProcess: inProcess,
      disabled: !valid || pristine
    }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0430\u0433\u0430\u0437\u0438\u043D")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ModifyForm;
exports["default"] = _default;